import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CandidateAdapter } from '@shared/models';
import { parseDate } from '@shared/utils';

@Component({
  selector: 'mojo-candidate-experience',
  templateUrl: './candidate-experience.component.html',
  styleUrls: ['./candidate-experience.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateExperienceComponent {
  @Input() candidate: CandidateAdapter;
  @Input() flexLayout = true;

  constructor() {}

  calculateDate(milliSeconds) {
    return parseDate(`${milliSeconds}`).toLocaleDateString();
  }
}
